module.exports = __webpack_public_path__ + "img/s (1).4ac493aa.png";